// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2Sg2l","title":"InfoRow_title__1QxWc"};